import React from "react";
import { Hero } from "../components/home/Hero";
import { OfferMarquee } from "../components/home/OfferMarquee";
import { Categories } from "../components/home/Categories";
import { OfferBanner } from "../components/home/OfferBanner";
import { BestSellers } from "../components/home/BestSellers";
import { NewArrivals } from "../components/home/NewArrivals";
import { HomeVideo } from "../components/home/HomeVideo";
import { WeddingBanner } from "../components/home/WeddingBanner";
import { Heritage } from "../components/home/Heritage";
import { WhyUs } from "../components/home/WhyUs";
import { Reviews } from "../components/home/Reviews";
import { InstaGrid } from "../components/home/InstaGrid";
import { WhatsAppBanner } from "../components/home/WhatsAppBanner";
import { Faq, FAQS } from "../components/home/Faq";
import { EditorialMarquee } from "../components/home/EditorialMarquee";
import { BestSellersCarousel } from "../components/home/BestSellersCarousel";
import { PromoBanner } from "../components/home/PromoBanner";
import { CountdownTimer } from "../components/home/CountdownTimer";
import { Reveal } from "../components/motion/Reveal";
import { useSEO } from "../lib/seo";

export default function HomePage() {
  useSEO({
    title: "Ilkal Sarees Online — Buy Authentic Handloom Ilkal Sarees from Karnataka | R V Ilkal Sarees",
    description: "Shop original Ilkal sarees online — traditional handloom Ilkal cotton and silk sarees woven in Ilkal, Karnataka. Pure Ilkal sarees with signature temple borders, pan-India delivery, COD and secure UPI payment.",
    canonicalPath: "/",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQS.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
    },
  });
  return (
    <main data-testid="home-page">
      <Hero />
      <OfferMarquee />
      <Reveal><Categories /></Reveal>
      <Reveal>
        <PromoBanner
          image="/early-access-banner.jpg"
          to="/shop?badge=new"
          testid="early-access-banner"
          ariaLabel="Early Access Unlocked — explore new arrival Ilkal sarees"
          fullBleed
        />
      </Reveal>
      <Reveal><OfferBanner /></Reveal>
      <Reveal><BestSellers /></Reveal>
      <EditorialMarquee />
      <Reveal>
        <PromoBanner
          image="/ready-to-wear-banner.jpg"
          to="/shop?category=daily"
          testid="ready-to-wear-banner"
          ariaLabel="The Ready-to-Wear Edit — 24-hour never before sale on daily wear Ilkal sarees"
          fullBleed
          overlay={<CountdownTimer />}
        />
      </Reveal>
      <Reveal><NewArrivals /></Reveal>
      <HomeVideo />
      <Reveal><WeddingBanner /></Reveal>
      <Reveal><Heritage /></Reveal>
      <Reveal><WhyUs /></Reveal>
      <Reveal><BestSellersCarousel /></Reveal>
      <Reveal><Faq /></Reveal>
      <Reveal><Reviews /></Reveal>
      <Reveal><InstaGrid /></Reveal>
      <Reveal><WhatsAppBanner /></Reveal>
    </main>
  );
}
